<mat-spinner color="secondary" *ngIf="!products"></mat-spinner>

<div class="error" *ngIf="products && products.length == 0">No Products Found</div>

@for (product of products; track product) {
  <a class="hero" [routerLink]="product.builderButton.link" [title]="product.image.alt">
    <img [src]="product.image.src" [alt]="product.image.alt" />
    <div class="title">
      <h1>{{ product.name }}</h1>
      <h3>{{ product.shortDescription }}</h3>
      <button *ngIf="product.builderButton.link" mat-flat-button color="primary" [routerLink]="product.builderButton.link">
        <span>
          <mat-icon *ngIf="product.builderButton.iconPosition === 'LEFT'" [svgIcon]="product.builderButton.icon"></mat-icon>
          {{product.builderButton.text}}
          <mat-icon *ngIf="product.builderButton.iconPosition === 'RIGHT'" [svgIcon]="product.builderButton.icon"></mat-icon>
        </span>
      </button>
    </div>
  </a>
  <div class="description" [ngClass]="{collapsed: descriptionCollapsed, collapsible: collapsingDescriptionEnabled}" (click)="heroClicked()" #description>
    <span [innerHtml]="product.description"></span>
    <div class="actions" *ngIf="collapsingDescriptionEnabled">
      <button mat-stroked-button color="tertiary" *ngIf="descriptionCollapsed">
        <span>
          read more
          <mat-icon svgIcon="chevron-down"></mat-icon>
        </span>
      </button>
      <button mat-stroked-button color="tertiary" *ngIf="!descriptionCollapsed">
        <span>
          read less
          <mat-icon svgIcon="chevron-up"></mat-icon>
        </span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="product.childrenDisplayStyle == 'details'">
    @for (product of product.children; track product.id) {
    <mbnm-shop-detail-product-merch [product]="product">
    </mbnm-shop-detail-product-merch>
    }
  </ng-container>

  <mbnm-shop-detail-product-blocks [products]="product.children" *ngIf="product.childrenDisplayStyle == 'thumb'">
  </mbnm-shop-detail-product-blocks>

  <ng-container *ngIf="products && products.length > 0 && products[0].reviewsTag">
    <mbnm-reviews class="reviews" [tag]="products[0].reviewsTag"></mbnm-reviews>
  </ng-container>
}
